import { Observable } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import * as Sentry from '@sentry/angular';

import { CORE_CONFIG } from '../../config/core-config';

function generateUUID(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

export const trackingInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const config = inject(CORE_CONFIG);
  if (!request.url.includes(config.apiBaseUrl)) {
    return next(request);
  }

  const requestId = generateUUID();
  const platform = Capacitor.getPlatform();

  request = request.clone({
    headers: request.headers
      .set('X-Request-ID', requestId)
      .set('X-App-Version', config.version)
      .set('X-App-Commit', config.commitHash)
      .set('X-App-Platform', platform),
  });

  Sentry.addBreadcrumb({
    category: 'http',
    // Sin query string: puede traer correos, matrículas o tokens (auditoría 2026-10).
    message: `${request.method} ${request.url}`,
    data: { requestId, platform },
    level: 'info',
  });

  return next(request);
};
